// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xlarge[data-v-684cb389]{max-width:80rem}`, "",{"version":3,"sources":["webpack://./vue/components/reveal-modal.vue"],"names":[],"mappings":"AACA,yBACI,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
